import React, {use, createContext, useEffect} from "react";
import PropTypes from "prop-types";
import SyncRegulationsForGroup from "./gql/SyncRegulationsForGroup.graphql";
import UpdateOneRegulationGroup from "./gql/UpdateOneRegulationGroup.graphql";
import {useMutation} from "@apollo/client";
import {useParams} from "react-router-dom";
import {ALERT} from "../environment";

const GroupsContext = createContext(null);

const GroupsProvider = ({children}) => {
  const [updateRegulationGroup, updateRegulationGroupMethods] =
    useMutation(UpdateOneRegulationGroup);

  const {id} = useParams();
  const groupId = parseInt(id, 10);

  const [syncGroupRegulations, syncGroupRegulationsMethod] = useMutation(SyncRegulationsForGroup);

  useEffect(() => {
    if (syncGroupRegulationsMethod.data) {
      ALERT.success("Regulation group updated!");
    }
  }, [syncGroupRegulationsMethod.data]);

  const loading =
    syncGroupRegulationsMethod.loading ||
    updateRegulationGroupMethods.loading;

  const update = async (data) => {
    await syncGroupRegulations({
      variables: {
        regulationGroupId: groupId,
        regulations: data.regulations,
      },
    });

    updateRegulationGroup({
      variables: {
        id: groupId,
        groupName: data.name,
      },
    });
  };

  return (
    <GroupsContext
      value={{
        update,
        loading,
      }}
    >
      {children}
    </GroupsContext>
  );
};

GroupsProvider.propTypes = {
  children: PropTypes.any.isRequired,
};

const useGroups = () => {
  return use(GroupsContext);
};

export {useGroups, GroupsProvider};
